import { getEveryUserContent } from '@/api/content';

export default {
  namespaced: true,
  state: {
    loading: false,
    content: [],
    pagination: {
      page: 0,
      limit: 10,
    },
    hasMore: true,
    orderOption: 'createdAt',
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setContent(state, payload) {
      state.content = state.content.concat(payload);
      if (payload.length < state.pagination.limit) {
        state.hasMore = false;
        state.pagination.page = 0;
      } else {
        state.pagination.page += 1;
      }
    },
    resetState(state) {
      state.content = [];
      state.pagination.page = 0;
      state.hasMore = true;
      state.orderOption = 'createdAt';
    },
    deleteContentItemFromStore(state, id) {
      state.content = state.content.filter(post => post.id !== id);
    },
    setOrderOption(state, option) {
      state.orderOption = option;
    },
  },
  actions: {
    async getContent({ commit, getters, dispatch }) {
      try {
        commit('setLoading', true);
        const { orderBy, pagination: { page, limit } } = getters;
        const { data } = await getEveryUserContent(page, limit, orderBy);
        commit('setContent', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading && !state.content.length,
    loadMoreLoading: state => state.loading && !!state.content.length,
    content: state => state.content || [],
    pagination: state => state.pagination,
    hasMore: state => state.hasMore && !!state.content.length,
    orderBy: state => state.orderOption,
  },
};
